import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';


export const CandidateResume = ({
  resumeLink,
  candidateName,
}: {
  resumeLink: string;
  candidateName: string;
}) => {
  const {t} = useLabelTranslation();
  return (
    <iframe
      src={resumeLink}
      title={`${t('Resume_for', 'Resume for')} ${candidateName}`}
      style={{height: '650px'}}
    ></iframe>
  );
};
